import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export const todayIso = (() => {
  const d = new Date();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${month}-${day}`;
})();

export function bloodBankDateSearch(dateRange: string, fromDate: string, toDate: string, status?: string) {
  const params = new URLSearchParams();
  if (dateRange) params.set("dateRange", dateRange);
  if (fromDate) params.set("fromDate", fromDate);
  if (toDate) params.set("toDate", toDate);
  if (status) params.set("status", status);
  return params.toString();
}

export function useBloodBankDateQuery(
  setPage?: (page: number) => void,
  withStatus = false
) {
  const [searchParams] = useSearchParams();
  const [dateRange, setDateRange] = useState(
    () => searchParams.get("dateRange") || "Today"
  );
  const [fromDate, setFromDate] = useState(
    () => searchParams.get("fromDate") || todayIso
  );
  const [toDate, setToDate] = useState(
    () => searchParams.get("toDate") || todayIso
  );
  const [statusFilter, setStatusFilter] = useState(
    () => searchParams.get("status") || ""
  );

  useEffect(() => {
    const range = searchParams.get("dateRange");
    const from = searchParams.get("fromDate");
    const to = searchParams.get("toDate");
    const hasDate = Boolean(range || from || to);
    const hasStatus = withStatus && searchParams.has("status");
    if (!hasDate && !hasStatus) return;

    if (range) setDateRange(range);
    if (from) setFromDate(from);
    if (to) setToDate(to);
    if (hasStatus) setStatusFilter(searchParams.get("status") || "");
    setPage?.(0);
  }, [searchParams, setPage, withStatus]);

  return {
    dateRange,
    setDateRange,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    statusFilter,
    setStatusFilter,
  };
}
